import ApiCore from './api-core'
import { DRIVER } from '@/constants/api-types'

export default class Load extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/order`
    super(store, path)
  }

  information(showProgress) {
    return this.request({
      action: 'information',
      method: 'GET',
      showProgress
    })
  }

  info(id, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'GET',
      showProgress
    })
  }

  detail(id, showProgress) {
    return this.request({
      action: `${id}/detail`,
      method: 'GET',
      showProgress
    })
  }

  cancel(id, showProgress) {
    return this.request({
      action: `${id}/cancel`,
      method: 'PATCH',
      showProgress
    })
  }

  pricingCargo(model, showProgress) {
    return this.request({
      action: `offer/create/cargo`,
      method: 'POST',
      body: model,
      showProgress
    })
  }

  pricingTrash(model, showProgress) {
    return this.request({
      action: `offer/create/trash`,
      method: 'POST',
      body: model,
      showProgress
    })
  }

  accept(id, showProgress) {
    return this.request({
      action: `${id}/accept`,
      method: 'PATCH',
      showProgress
    })
  }
}
